<template>
  <v-layout>

    <v-flex>
      <v-row align="center" no-gutters class="">
        <v-col class="text-left ml-n6 mt-n4">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          {{ forUpdate ? 'Update' : 'Create New' }} Overseas Warehouse
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="text--primary mt-6">

          <AlertMessage :alerMessage="alerMessage"></AlertMessage>

          <ValidationObserver ref="observer" v-slot="{ validate, reset }">
            <form
              v-on:submit.prevent>
              <v-row class="pa-0">
                <v-col cols="12">
                  <ValidationProvider v-slot="{ errors }" name="Code" rules="required|max:100">
                    <v-text-field
                      v-model="location.code"
                      maxlength="100"
                      :error-messages="errors"
                      label="Code"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12">
                  <ValidationProvider v-slot="{ errors }" name="Name" rules="required|max:100">
                    <v-text-field
                      v-model="location.name"
                      maxlength="100"
                      :error-messages="errors"
                      label="Name"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>


              <v-btn class="d-none" @click="reset"></v-btn>
            </form>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary mr-4"
            depressed
            large
            @click="submit">
            <span class="mx-4">
              {{ loading ? 'Please wait...' : '' }}
              {{ !loading ? forUpdate ? 'Update Overseas Warehouse' : 'Create Overseas Warehouse' : '' }}
            </span>
          </v-btn>
          <v-btn
            v-if="!loading"
            depressed
            large
            @click="clear">
            <span class="mx-4">
              Reset Form
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>

    </v-flex>
  </v-layout>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import { required, email, max } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import AlertMessage from '@/components/AlertMessage.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  extend('max', {
    ...max,
    message: '{_field_} may not be greater than {length} characters',
  })

  export default {
    name: 'location',
    data: () => ({
      adminNamespace: 'admin',
      id: null,
      loading: false,
      subNavs: [
        {
          text: 'Overseas Warehouses',
          disabled: false,
          exact: true,
          to: {
            name: 'locations'
          },
        },
        {
          text: 'Create New Overseas Warehouse',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      location: {
        code: '',
        name: ''
      }
    }),
    computed: {
      forUpdate: function(){
        return this.id ? true : false
      }
    },
    methods: {
      getLocation () {
        this.loading = true
        let self = this
        this.$http.plain.get(this.adminNamespace+'/locations/'+this.id)
          .then(response => {
            this.location = response.data
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        },
      addNew () {
        let self = this

        this.$http.secured.post(this.adminNamespace+'/locations', this.location)
          .then(response => {
            this.$router.push({ name: 'locations', query: { added: true, message: "Location has been successfully added" } })
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      update () {
        let self = this
        delete this.location['id']

        this.$http.secured.put(this.adminNamespace+'/locations/'+this.id, this.location)
          .then(response => {
            this.showMessage(response.data.name + " has been successfully updated", 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })

      },
      async submit () {

        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return false;
        }

        if(this.loading){
          return false;
        }

        this.loading = true

        if(this.forUpdate){
          this.update()
        }else{
          this.addNew()
        }
      },
      clear () {
        Object.keys(this.location).forEach(key => {
          this.location[key] = ''
        })

        this.$refs.observer.reset()

        if(this.forUpdate){
          this.getLocation()
        }
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      if(this.$route.params.id != 'add'){

        this.subNavs[1].text = 'Update Location'
        this.id = this.$route.params.id
        this.getLocation()
      }
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      SnackBar,
      AlertMessage
    }
  }
</script>
